import { ROLE_MANAGEMENT_V1 } from "api/ApiPath";
import client from "api/client";
import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { injectable } from "tsyringe";
import { RoleResponseModel } from "./model/RoleResponseModel";

export type IRoleRepository = {
  getRolesFilter(): Promise<BaseApiResponseModel<RoleResponseModel[]>>;
};

@injectable()
export class RoleRepositoryImpl implements IRoleRepository {
  async getRolesFilter(): Promise<BaseApiResponseModel<RoleResponseModel[]>> {
    return await client.get(ROLE_MANAGEMENT_V1?.FILTER, {
      limit: 1000,
      order: "name asc",
    });
  }
}
